import profileRequest from '@ertelecom/ui-react/components/requests/profileRequest';

export interface IProducts {
    tariffPriceMvno: number,
    salePackageId: number,
    tariffPrice: number,
    tariffName: string,
    tariffPriceDiscount: number,
    services: IServices[],
}

export interface IServices {
    productId: number,
    productName: string,
    planId: number,
    planName: string,
    specification: number,
    activated: 0 | 1,
    terminalResources: ITerminalResources[],
}

export interface ITerminalResources {
    id: number,
    name: string,
    serviceId: number,
    type: string,
}


/**
 * GET-запрос подключенных у клиента скоростных бонусов
 * @param {string} domain поддомен хоста b2c
 * @param {string} accessToken токен доступа
 * @return {Promise<IProducts>}
 */
export async function getProductsInfo(domain: string, accessToken: string): Promise<IProducts> {
    const response = await profileRequest(domain, accessToken).get('/info/products');
    return response.data;
}
